// 27KH #109219 add
import { MCBMS010CreateRequest } from "types/MCBMS010/MCBMS010CreateRequest";
import request from 'utils/request'

export const loginPermissionIpAddressCreate = (loginPermissionIpAddress:MCBMS010CreateRequest) =>
request({
    url:'/MCBMS010/resister',
    method:'post',
    data:loginPermissionIpAddress,
})

export const loginPermissionIpAddressDetailRequest = () =>
  request({
    url: `/MCBMS010/init`,
    method: 'post',
  })